import { calculateCalendarDuration } from "@/lib/calendar/calendar-range-utils";

const CITY_ALIASES: Record<string, readonly string[]> = {
  casablanca: ["casablanca"],
  marrakech: ["marrakech", "marrakesh"],
  marrakesh: ["marrakech", "marrakesh"],
  agadir: ["agadir"],
  rabat: ["rabat"],
  tanger: ["tanger", "tangier"],
  tangier: ["tanger", "tangier"],
  fes: ["fes", "fès", "fez"],
  fès: ["fes", "fès", "fez"],
  fez: ["fes", "fès", "fez"],
};

const fold = (value: string): string =>
  value.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();

const parseSearchDay = (value: string): Date | null => {
  const day = value.trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;
  const [year, month, date] = day.split("-").map(Number);
  const parsed = new Date(year, month - 1, date);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/** Nuits de location. Null si les dates sont absentes ou illisibles : on ne filtre pas. */
export const tripDurationDays = (
  start: string | null | undefined,
  end: string | null | undefined
): number | null => {
  if (!start?.trim() || !end?.trim()) return null;
  const startDate = parseSearchDay(start);
  const endDate = parseSearchDay(end);
  if (!startDate || !endDate) return null;
  const days = calculateCalendarDuration({ startDate, endDate });
  return days >= 1 ? days : null;
};

/** Filtre PostgREST `or` pour les alias de ville. Une seule variante reste un ilike simple. */
export const locationSearch = (
  raw: string | null | undefined
): { kind: "ilike"; pattern: string } | { kind: "or"; filter: string } | null => {
  const token = raw?.trim();
  if (!token) return null;
  const safe = token.replace(/[%_,.()]/g, "");
  if (!safe) return null;
  const variants = CITY_ALIASES[fold(safe)] ?? CITY_ALIASES[safe.toLowerCase()] ?? [safe];
  const unique = [...new Set(variants.map((variant) => variant.replace(/[%_,.()]/g, "")))].filter(Boolean);
  if (unique.length <= 1) {
    return { kind: "ilike", pattern: `%${unique[0] ?? safe}%` };
  }
  return {
    kind: "or",
    filter: unique.map((variant) => `location.ilike.%${variant}%`).join(","),
  };
};
